import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";

import { useDeleteUser, useDeleteUserInvitation } from "../api/deleteUser";

const DeleteUser = ({
  cmsUserId = "",
  invitationId,
  handleEditUserModal,
}: {
  cmsUserId: string;
  invitationId?: string;
  handleEditUserModal: (data: { data: null; newIsEditUserOpen: boolean }) => void;
}) => {
  const deleteUserMutation = useDeleteUser();
  const deleteUserInvitationMutation = useDeleteUserInvitation();

  const [isShowDeleteButton, setIsShowDeleteButton] = useState(false);

  const onDelete = () => {
    if (invitationId) {
      deleteUserInvitationMutation.mutate(
        { cmsUserId, invitationId },
        {
          onSuccess: () => {
            handleEditUserModal({ data: null, newIsEditUserOpen: false });
          },
        }
      );
    } else {
      deleteUserMutation.mutate(cmsUserId, {
        onSuccess: () => {
          handleEditUserModal({ data: null, newIsEditUserOpen: false });
        },
      });
    }
  };

  const showDeleteButton = () => {
    setIsShowDeleteButton(true);
  };

  return (
    <>
      <Typography variant="h6" component="h2" sx={{ mb: 2, fontWeight: 500 }}>
        Delete User
      </Typography>

      <Typography variant="body2" sx={{ mb: 3, fontSize: "12px", lineHeight: 1.4 }}>
        This action cannot be undone.
        <br />
        All access given to this user will be removed immediately.
      </Typography>

      {isShowDeleteButton ? (
        <Button
          onClick={onDelete}
          disabled={deleteUserMutation.isPending}
          color="error"
          variant="contained"
          sx={{ textTransform: "none" }}
        >
          {deleteUserMutation.isPending ? "Deleting..." : "Click to Confirm Delete User"}
        </Button>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={showDeleteButton}
            color="error"
            variant="outlined"
            sx={{ textTransform: "none" }}
          >
            Delete User
          </Button>
        </Box>
      )}
    </>
  );
};

export default DeleteUser;
